<template>
  <div class="card">
    <div class="card-image" v-if="$slots.image">
      <slot name="image"></slot>
    </div>
    <div class="card-header d-flex justify-content-between" v-if="$slots.header || title">
      <slot name="header">
        <div v-if="title">
          <h4 class="card-title">{{title}}</h4>
          <p class="card-category" v-if="subTitle">{{subTitle}}</p>
        </div>
      </slot>
      <slot name="header-right"></slot>
    </div>
    <div class="card-body" v-if="$slots.default">
      <slot></slot>
    </div>
    <slot name="raw-content"></slot>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    title: String,
    subTitle: String
  }
};
</script>
<style>
</style>
